import { Card, Flex, NumberInput, Text, Title } from '@tremor/react'
import type { InputsState, Labels } from '../types'

interface Props {
    inputs: InputsState
    setInputs: (updates: Partial<InputsState>) => void
    labels: Labels
}

export default function StorageStep({ inputs, setInputs, labels }: Props) {
    return (
        <Card className="bg-teal-800 ring-teal-900">
            <Title className="text-lg mb-2 text-white">Storage</Title>
            <Flex
                justifyContent="between"
                alignItems="center"
                className="flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">
                    {labels.objectStorage} hot tier (TB)
                </Text>
                <NumberInput
                    value={inputs.s3StandardTb}
                    onValueChange={(v) => setInputs({ s3StandardTb: v })}
                    min={0}
                    step={0.5}
                    className="w-full md:w-48"
                />
            </Flex>
            <Flex
                justifyContent="between"
                alignItems="center"
                className="flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">
                    {labels.objectStorage} infrequent/cold (TB)
                </Text>
                <NumberInput
                    value={inputs.s3IaTb}
                    onValueChange={(v) => setInputs({ s3IaTb: v })}
                    min={0}
                    step={0.5}
                    className="w-full md:w-48"
                />
            </Flex>
            <Flex
                justifyContent="between"
                alignItems="center"
                className="flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">
                    {labels.blockStorage} (TB)
                </Text>
                <NumberInput
                    value={inputs.ebsTb}
                    onValueChange={(v) => setInputs({ ebsTb: v })}
                    min={0}
                    step={0.5}
                    className="w-full md:w-48"
                />
            </Flex>
            <Flex
                justifyContent="between"
                alignItems="center"
                className="flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">
                    {labels.snapshotWord} (TB)
                </Text>
                <NumberInput
                    value={inputs.snapshotsTb}
                    onValueChange={(v) => setInputs({ snapshotsTb: v })}
                    min={0}
                    step={0.5}
                    className="w-full md:w-48"
                />
            </Flex>
        </Card>
    )
}
